import { Settings } from 'luxon'

Settings.defaultLocale = 'de'

// When a new deployment occurs, the hosting service may delete the assets from previous deployments. As a result, a user who visited your site before the new deployment might encounter an import error.
// Here, we reload the page to fix this.
// @see https://vite.dev/guide/build#load-error-handling
window.addEventListener('vite:preloadError', (event) => {
    event.preventDefault()
    window.location.reload()
})
